import { blue } from '@material-ui/core/colors';
import { Theme } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import Color from 'color';

export default {
  forms: {
    subPanels: (theme: Theme) => ({
      flex: 1,
      padding: theme.spacing(2),
    }),
    formControl: (theme: Theme) => ({
      marginTop: theme.spacing(1),
    }),
    buttonProgress: (theme: Theme) => ({
      marginRight: theme.spacing(1),
    }),
    formGrid: (theme: Theme) => ({
      marginTop: theme.spacing(0.5),
    }),
    checkbox: (theme: Theme) => ({
      color: theme.palette.primary.main,
    }),
    datePicker: (theme: Theme) => ({
      color: theme.palette.primary.main,
    }),
    circleButtons: (theme: Theme) => ({
      width: theme.spacing(3.5) - 1,
      height: theme.spacing(3.5) - 1,
      borderRadius: '50%',
      minWidth: 'auto',
      marginRight: theme.spacing(0.25),
      display: 'inline-flex',
    }),
    skeletonButtons: (theme: Theme) => ({
      height: theme.spacing(4),
    }),
    dangerButtons: (theme: Theme) => ({
      color: theme.palette.getContrastText(theme.palette.error.main),
      backgroundColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: Color(theme.palette.error.main).darken(0.2).toString(),
        '@media (hover: none)': {
          backgroundColor: Color(theme.palette.error.main).alpha(0.3).toString(),
        },
      },
    }),
  },
  dialog: {
    messageBox: {
      buttons: (theme: Theme) => ({
        minWidth: theme.spacing(15),
        margin: `0px ${theme.spacing(0.5)}px`,
      }),
    },
  },
  table: {
    grid: (): CSSProperties => ({
      outline: 'none',
    }),
    headerRow: (theme: Theme) => ({
      display: 'flex',
      color: theme.palette.getContrastText(theme.palette.error.main),
      backgroundColor: `${theme.palette.primary.main} !important`,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      paddingRight: '0 !important',
    }),
    headerCell: (theme: Theme) => ({
      height: theme.spacing(4),
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      fontWeight: 500,
      'box-sizing': 'border-box',
    }),
    headerCellButton: (theme: Theme) => ({
      flex: 1,
      color: theme.palette.common.white,
      justifyContent: 'flex-start',
      paddingLeft: 0,
      minWidth: 40,
    }),
    headerCellButtonSorted: (theme: Theme) => ({
      flex: 1,
      color: theme.palette.common.white,
      backgroundColor: Color(theme.palette.primary.dark).darken(0.3).toString(),
      justifyContent: 'flex-start',
      paddingLeft: 0,
    }),
    headerCellSortIcon: (theme: Theme): CSSProperties => ({
      position: 'absolute',
      right: theme.spacing(0.5),
      bottom: theme.spacing(0.5),
    }),
    oddRow: (theme: Theme) => ({
      display: 'flex',
      backgroundColor: blue[50],
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize + 1,
      fontWeight: 300,
      cursor: 'pointer',
      'box-sizing': 'border-box',
      '&:hover': {
        backgroundColor: blue[200],
      },
    }),
    eventRow: (theme: Theme) => ({
      display: 'flex',
      backgroundColor: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize + 1,
      fontWeight: 300,
      cursor: 'pointer',
      'box-sizing': 'border-box',
      '&:hover': {
        backgroundColor: blue[200],
      },
    }),
    selectedRow: (theme: Theme) => ({
      display: 'flex',
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      'box-sizing': 'border-box',
    }),
    cell: (theme: Theme) => ({
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      'box-sizing': 'border-box',
    }),
    cellSorted: (theme: Theme) => ({
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      'box-sizing': 'border-box',
      backgroundColor: Color(theme.palette.background.default).alpha(0.3).toString(),
    }),
  },
};
